import React, { InputHTMLAttributes } from 'react';
import Gap from '../../interfaces/gap.interface';
import TestId from '../../interfaces/test-id.interface';
import FormElement, { Props as FormElementProps } from '../form-element/form-element.component';
import Icon from '../icon/icon.component';

export interface Props
  extends InputHTMLAttributes<HTMLSelectElement>,
    FormElementProps,
    Gap,
    TestId {
  /** An optional label rendered in front of the input */
  label?: string;

  /** The input's id */
  id: string;

  /** Optional message rendered underneath the input */
  message?: React.ReactNode;

  /** How to render the label + input element (defaults to `inline`) */
  variant?: 'inline' | 'stacked';
}

/** HTML Form Select Element */
const Select = React.forwardRef(
  (
    {
      children,
      defaultValue,
      disabled = false,
      gap = 'none',
      id,
      label,
      message,
      required,
      state = 'indeterminate',
      variant = 'inline',
      testId,
    }: Props,
    ref: React.Ref<HTMLSelectElement>
  ): React.ReactElement => (
    <FormElement
      gap={gap}
      id={id}
      label={label}
      message={message}
      testId={testId}
      variant={variant}
    >
      <div className="relative w-full">
        <select
          className={`
            skeletonize
            appearance-none
            bg-white
            block
            border
            border-gray-300
            hover:border-gray-500
            leading-tight
            pr-8
            px-3
            py-2
            rounded-none
            w-full
            ${state}
          `}
          defaultValue={defaultValue}
          disabled={disabled}
          required={required}
          ref={ref}
          id={id}
          name={id}
        >
          {children}
        </select>
        <Icon
          className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          name="angle-down"
        />
      </div>
    </FormElement>
  )
);

export default Select;
